import { IOperation } from '@/contracts/system-modules/sync/operation/IOperation'

export class PushOperationsParams {
  operations: IOperation[]

  constructor({ operations }: { operations: IOperation[] }) {
    this.operations = operations
  }
}
